import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78aa5d18&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=78aa5d18&prod&scoped=true&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=78aa5d18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78aa5d18",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Recruit: require('/drone/src/components/recruit/index.vue').default,Empty: require('/drone/src/components/Empty/index.vue').default})
